"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Animate = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _animations = require("../animations/animations");

var _getDuration = _interopRequireDefault(require("../utils/getDuration"));

var _getDelay = _interopRequireDefault(require("../utils/getDelay"));

var _convertToSeconds = _interopRequireDefault(require("../utils/convertToSeconds"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var getAnimationMixins = function getAnimationMixins(animationCfg) {
  // Get the keyframes for the animations being run
  var animationKeyFrames = animationCfg.animations.map(function (animationName) {
    if (animationName === 'none') return;
    return _animations.animations[animationName].animation();
  }); // Gets the animation CSS

  var animationCss = animationCfg.animations.map(function (animationName) {
    if (animationName === 'none') return;
    var animationDuration = (0, _getDuration["default"])(animationCfg, animationName);
    return "".concat(animationName, " ").concat((0, _convertToSeconds["default"])(animationDuration), "s ").concat((0, _convertToSeconds["default"])((0, _getDelay["default"])(animationCfg)), "s");
  }).join(', ');
  return (0, _styledComponents.css)(["", " animation:", ";"], animationKeyFrames, animationCss);
};

var Animate = _styledComponents["default"].span.withConfig({
  displayName: "Animatestyle__Animate",
  componentId: "sc-17pgmc7-0"
})(function (props) {
  return (0, _styledComponents.css)([".animation-container{&-enter{", " animation-fill-mode:both;}&-exit{", " animation-fill-mode:both;}}"], getAnimationMixins(props.enter), getAnimationMixins(props.exit));
});

exports.Animate = Animate;
//# sourceMappingURL=Animate.style.js.map